<template>
    <div class="c-mapbox-templating__attribution">
        <a href="https://www.mapbox.com/about/maps/" target="_system">&copy; Mapbox &copy; OpenStreetMap</a>
        <a class="mapbox-improve-map" href="https://www.mapbox.com/map-feedback/" target="_system">Improve this map</a>
    </div>
</template>

<style lang="scss">
    .c-mapbox-templating__attribution{
        display: none;
    }
</style>

<script>
    export default {
        name: "attribution",
        props: ["map"],
        mounted() {
            this.map.layers.attribution = L.control.attribution({ prefix: false })
                .addAttribution(jQuery(this.$el).html());
        }
    };
</script>


// WEBPACK FOOTER //
// Assets/Scripts/Components/Mapbox/attribution/attribution.vue